import { createAsyncTypes } from 'utils/ActionCreator'

import { SUBMIT_EULA_ASYNC } from 'containers/EULAModal/constants'
import { SUBMIT_FIRST_LOGIN_ASYNC } from 'containers/FirstLoginModal/constants'
import { GROUP_SETTINGS_DATA_REQUEST_ASYNC } from 'containers/GroupSettings/Table/constants'
import { NEW_COMPANY_ADD_ASYNC } from 'containers/Partner/constants'
import { DISABLE_365_INTEGRATION_REQUEST_ASYNC } from 'containers/Settings/EmailServer/O365/constants'
import { UPDATE_GENERAL_SETTINGS_REQUEST } from 'containers/Settings/General/constants'
import { SUBMIT_INCIDENT_RESPONSE_ASYNC } from 'containers/Settings/Incidence/constants'
import {
  FORCE_REFETCH_FFS,
  TOGGLE_SPAM_FF_REQUEST_ASYNC,
} from 'containers/Settings/Intelligence/constants'
import { UPDATE_LANGUAGES_ASYNC } from 'containers/Settings/Languages/constants'
import { UPDATE_DATA_ASYNC } from 'containers/Settings/MicrosoftQuarantine/constants'
import { SET_FREE_TRIAL_STATUS } from 'containers/UpgradeLicenseModal/constants'

export const FETCH_APP_DATA_ASYNC = createAsyncTypes('FETCH_APP_DATA', 'App')
export const FETCH_APP_NOTIFICATIONS_ASYNC = createAsyncTypes('FETCH_APP_NOTIFICATIONS', 'App')
export const DISMISS_NOTIFICATION_ASYNC = createAsyncTypes('DISMISS_NOTIFICATION', 'App')
export const REFETCH_OWNER_STATUS_ASYNC = createAsyncTypes('REFETCH_OWNER_STATUS', 'App')
export const UPDATE_AI_CREDITS_NOTIFICATION = 'App/UPDATE_AI_CREDITS_NOTIFICATION'
export const MERGE_AI_CREDITS_NOTIFICATION = 'App/MERGE_AI_CREDITS_NOTIFICATION'

// Plan types by ID
export const PLAN_TYPES = {
  CAMPAIGNS_ONLY: 1,
  STARTER: 2,
  CORE: 3,
  EMAIL_PROTECT: 4,
  COMPLETE_PROTECT: 5,
  IRONSCALES_PROTECT: 6,
  SAT_SUITE: 7,
  EMAIL_ESSENTIALS: 8,
  EMAIL_PROTECT_VAR: 9,
  EMAIL_PROTECT_PRO: 10,
}

// Plan types by weights
export const PLAN_TYPES_RANGED = {
  [PLAN_TYPES.CAMPAIGNS_ONLY]: 1,
  [PLAN_TYPES.SAT_SUITE]: 1.5,
  [PLAN_TYPES.STARTER]: 2,
  [PLAN_TYPES.IRONSCALES_PROTECT]: 2.5,
  [PLAN_TYPES.CORE]: 3,
  [PLAN_TYPES.EMAIL_ESSENTIALS]: 3.5,
  [PLAN_TYPES.EMAIL_PROTECT]: 4,
  [PLAN_TYPES.EMAIL_PROTECT_VAR]: 4,
  [PLAN_TYPES.EMAIL_PROTECT_PRO]: 4.5,
  [PLAN_TYPES.COMPLETE_PROTECT]: 5,
}

export const ADDONS = {
  PREMIUM: 'ironschool_premium_type',
  SIMULATION_AND_TRAINING_BUNDLE: 'simulation_and_training_bundle',
  SIMULATION_AND_TRAINING_BUNDLE_PLUS: 'simulation_and_training_bundle_plus',
  AI_EMPOWER_BUNDLE: 'ai_empower_bundle',
  DMARC_MANAGEMENT: 'dmarc_management',
}

export const REFETCH_APP_DATA_ACTIONS = [
  UPDATE_LANGUAGES_ASYNC.SUCCESS,
  UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS,
  SET_FREE_TRIAL_STATUS.SUCCESS,
  SUBMIT_EULA_ASYNC.SUCCESS,
  SUBMIT_FIRST_LOGIN_ASYNC.SUCCESS,
  NEW_COMPANY_ADD_ASYNC.SUCCESS,
  DISABLE_365_INTEGRATION_REQUEST_ASYNC.SUCCESS,
  SUBMIT_INCIDENT_RESPONSE_ASYNC.SUCCESS,
  GROUP_SETTINGS_DATA_REQUEST_ASYNC.SUCCESS,
  TOGGLE_SPAM_FF_REQUEST_ASYNC.SUCCESS,
  FORCE_REFETCH_FFS,
  UPDATE_DATA_ASYNC.SUCCESS,
]

export const ENGLISH_LANGUAGE = {
  name: 'English',
}

export const REGIONS = {
  US: 'US',
  EU: 'EU',
  AE: 'AE',
  IN: 'IN',
  CA: 'CA',
}
